module.exports = __webpack_public_path__ + "static/assets/34906e92db0f4c33c48980bd7ccb9638.png";